import { finintellectModelLabel } from './finintellectModelLabel';
import type { FinIntellectModel } from './types';

type FinIntellectModelCodeProps = {
  model?: FinIntellectModel | null;
  className?: string;
};

export const FinIntellectModelCode = ({
  model,
  className,
}: FinIntellectModelCodeProps) => {
  const classes = ['nq-model-code', className].filter(Boolean).join(' ');

  return (
    <code className={classes}>{finintellectModelLabel(model)}</code>
  );
};
